export function isValidMsisdn(msisdn: string): boolean {
  const regex = new RegExp("^(\\+98|0)?9\\d{9}$");
  const result = regex.test(msisdn);
  return result;
}
